import { Breakpoints } from 'types/components'

export const breakpointsToDevice = (breakpoints: Breakpoints) => {
  if (breakpoints.phones || breakpoints.tablets) return 'mobile'
  if (breakpoints.desktops) return 'desktop'

  return 'unknown'
}
